import React from "react";
import { Footer, Navbar, AnnouncementBar } from "../components";
const ContactPage = () => {
  return (
    <>
  <AnnouncementBar />
  <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">About Us</h1>
        <hr />
        
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p className="lead text-center mb-4">
              🌟 <strong>Discover PrimeBrothers</strong> — where family values meet modern shopping! 🌟
            </p>
            
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-users text-primary me-3 mt-1"></i>
                    <div>
                      <strong>Family Business:</strong> Born from the bond of eight brothers creating a trusted destination
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-star text-warning me-3 mt-1"></i>
                    <div>
                      <strong>Handpicked Quality:</strong> Every product is carefully selected for style and durability
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-tag text-success me-3 mt-1"></i>
                    <div>
                      <strong>Unbeatable Prices:</strong> Premium products at prices that won't break the bank
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-truck-fast text-info me-3 mt-1"></i>
                    <div>
                      <strong>Lightning-Fast Delivery:</strong> Free shipping across Pakistan on orders over Rs 2,000
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-shield-alt text-danger me-3 mt-1"></i>
                    <div>
                      <strong>100% Satisfaction:</strong> Easy returns and exchanges within 7 days guarantee
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-tshirt text-purple me-3 mt-1"></i>
                    <div>
                      <strong>Fashion Forward:</strong> Trendy clothing that makes you stand out from the crowd
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-mobile-alt text-dark me-3 mt-1"></i>
                    <div>
                      <strong>Latest Electronics:</strong> Cutting-edge technology to keep you connected always
                    </div>
                  </li>
                  <li className="mb-3 d-flex align-items-start">
                    <i className="fa fa-heart text-danger me-3 mt-1"></i>
                    <div>
                      <strong>Customer First:</strong> Your satisfaction is our top priority and commitment
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="text-center mt-4 mb-4">
              <p className="lead">
                <strong>🎉 Join thousands of happy customers</strong> who trust PrimeBrothers for their fashion and tech needs!
              </p>
            </div>
            
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="card border-0 bg-light">
                  <div className="card-body text-center">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2 d-flex align-items-center justify-content-center">
                        <i className="fa fa-map-marker-alt text-primary me-3"></i>
                        <div><strong>Head Office:</strong> PrimeBrothers, District Shikarpur, Sindh, Pakistan</div>
                      </li>
                      <li className="mb-2 d-flex align-items-center justify-content-center">
                        <i className="fa fa-clock text-success me-3"></i>
                        <div><strong>Customer Support:</strong> Mon–Sat, 10:00 AM – 7:00 PM PKT</div>
                      </li>
                      <li className="mb-0 d-flex align-items-center justify-content-center">
                        <i className="fa fa-comments text-info me-3"></i>
                        <div><strong>Ready to Help:</strong> Your satisfaction is our priority!</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2 className="text-center py-4">Our Products</h2>
        <div className="row">
          <div className="col-md-4 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://images.pexels.com/photos/298863/pexels-photo-298863.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Men's Clothing</h5>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://images.pexels.com/photos/7679720/pexels-photo-7679720.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Women's Clothing</h5>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Electronics</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .text-purple {
          color: #6f42c1 !important;
        }
      `}</style>
      
      <Footer />
    </>
  );
};

export default ContactPage;
